import React, { useMemo } from 'react';
import { DEFAULT_TABLE_PAGE_SIZE } from '@common/constants';
import { EUserProfilePreferenceAttributeName, EUserProfilePreferenceType } from './userProfilePreferences.constants';
import { useFetchUserPreferences } from './userProfilePreferences.queries';

export const useUserProfilePreferences = <T>(
  attributeName: EUserProfilePreferenceAttributeName | undefined,
  defaultValue: T,
  enabled?: boolean,
) => {
  const { data } = useFetchUserPreferences(!!attributeName && enabled);

  const value: T = useMemo(() => {
    const preference = data?.items?.find((item) => item.preference.attribute === attributeName);
    if (preference?.preference.attributeType === EUserProfilePreferenceType.BOOLEAN) {
      return (preference.value === 'true') as T;
    }
    if (preference?.preference.attributeType === EUserProfilePreferenceType.PAGE_SIZE_DROPDOWN) {
      return preference?.value && preference.value !== 'undefined' ? (Number(preference?.value) as T) : defaultValue;
    }
    return preference?.value && preference.value !== 'undefined' ? (preference?.value as T) : defaultValue;
  }, [JSON.stringify(data), attributeName]);
  return value;
};

export const useUserProfilePreferencesPageSize = (attributeName: EUserProfilePreferenceAttributeName | undefined) => {
  const initPageSize = useUserProfilePreferences<number>(attributeName, DEFAULT_TABLE_PAGE_SIZE);
  const [pageSize, setPageSize] = React.useState<number>(initPageSize);
  return { initPageSize, pageSize, setPageSize };
};
